import { ListItem, ListItemButton, ListItemText, useTheme } from '@mui/material';
import { Fragment } from 'react';

interface IProps {
	icon?: any;
	name: string;
	handleClick: any;
	open?: boolean;
	hasSubmenu?: boolean;
	styleObj?: any;
	submenuOpen?: boolean;
}

export const MenuListItem = ({ icon, name, handleClick, open, hasSubmenu, styleObj, submenuOpen }: IProps) => {
	const theme = useTheme();

	return (
		<Fragment>
			<ListItem
				sx={{
					borderRadius: '4px',
					color: theme.palette.root.basicWhite,
					display: open ? 'block' : 'flex',
					flexDirection: 'column',
					...styleObj,
				}}
			>
				<ListItemButton
					onClick={handleClick}
					sx={{
						gap: 1,
						borderRadius: '4px',
						'&:hover': { background: theme.palette.root.sideBarHoverGreen },
					}}
				>
					{icon && <img src={`/icons/${icon}.svg`} style={{ filter: 'brightness(0) invert(1)' }} />}
					{open && <ListItemText primary={name} />}
					{hasSubmenu && open && (
						<img
							src={submenuOpen ? '/icons/arrow-up.svg' : '/icons/arrow-down.svg'}
							style={{ filter: 'brightness(0) invert(1)' }}
						/>
					)}
				</ListItemButton>
			</ListItem>
		</Fragment>
	);
};
